import { render, staticRenderFns } from "./Subentro.vue?vue&type=template&id=2403c24d&scoped=true&"
import script from "./Subentro.vue?vue&type=script&lang=js&"
export * from "./Subentro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2403c24d",
  null
  
)

export default component.exports